import { render, staticRenderFns } from "./DebtYears.vue?vue&type=template&id=46568802&scoped=true&"
import script from "./DebtYears.vue?vue&type=script&lang=js&"
export * from "./DebtYears.vue?vue&type=script&lang=js&"
import style0 from "./DebtYears.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DebtYears.vue?vue&type=style&index=1&id=46568802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46568802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
